import React from 'react';
import CircularProgress from 'widgets/CircularProgress';
import './AppLoader.scss';

const Loader = () => (
  <div className="CircularProgress">
    <CircularProgress size={70} thickness={3} className="CircularProgress__Spinner" />
  </div>
);
export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/AppLoader.jsx